import {AxiosError, AxiosResponse} from "axios";
import {Axios} from "../../../axiosHelper";
import {ResponseBase} from "../../data";
import {DeviceCommandListResponse, DeviceCommandRequest} from "../../data/deviceCommand";
import {deviceCommandActions} from "../../slice/efe/deviceCommandSlice";

export const getDeviceCommandList = (systemId: string): any => {
  return async (dispatch: any) => {
    dispatch(deviceCommandActions.setLoading(true));

    Axios.get(`/efe/device-command/list/${systemId}`)
      .then((res: AxiosResponse<DeviceCommandListResponse>) => {
        dispatch(deviceCommandActions.setCommandList(res.data.commands));
      })
      .catch((err: AxiosError) => {
        if (err.response) {
          if (err.response.status === 400) {
            const resp: any = err.response.data;
            dispatch(deviceCommandActions.setError(resp));
          }
        }
      });
  };
};

export const addNewDeviceCommand = (request: DeviceCommandRequest): any => {
  return async (dispatch: any) => {
    dispatch(deviceCommandActions.setLoading(true));

    Axios.post("/efe/device-command/new", request, {
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((res: AxiosResponse<ResponseBase>) => {
        dispatch(deviceCommandActions.setResponse(res.data));
      })
      .catch((err: AxiosError) => {
        if (err.response) {
          if (err.response.status === 400) {
            const resp: any = err.response.data;
            dispatch(deviceCommandActions.setError(resp));
          }
        }
      });
  };
};

export const clearDeviceCommandResponse = (): any => {
  return async (dispatch: any) => {
    dispatch(deviceCommandActions.setResponse(null));
  };
};

export const clearDeviceCommandError = (): any => {
  return async (dispatch: any) => {
    dispatch(deviceCommandActions.setError(null));
  };
};
